export class OpnProjectDeadlineListViewModel {
  id: number;
  requestId: number;

  description:string;
  taskName: string;
  deadlineForCompletion: Date;
  organizationalUnitName: string;
  displaysToSuppliers: boolean;
  taskId: number;
}


export class OpnProjectDeadlineListSaveModel {
  id:number;
  requestId: number;
  taskId: number;
  deadlineForCompletion: Date;
  organizationalUnitId: number;
  displaysToSuppliers: boolean;
}

export class OpnProjectDeadlineListDetailsModel {
  id:number;
  requestId: number;
  taskId: number;

  deadlineForCompletion: Date;
  organizationalUnitId: number;
  displaysToSuppliers: boolean;
  taskName: string;
  description:string;
  organizationalUnitName: string;
}
